/**
 * MWF Analytics Tracking — Batch 2
 *
 * 1. form_submit dataLayer push (routes to GA4 via GTM)
 * 2. UTM capture + preservation across sessions + cart attribution
 *
 * Loaded deferred from layout/theme.liquid.
 */
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  // ---------------------------------------------------------------------------
  // 1. FORM SUBMIT TRACKING
  // ---------------------------------------------------------------------------
  // Any <form> submission fires a dataLayer form_submit event with the form's
  // id (or a fallback descriptor). Configure a GTM trigger on
  // Custom Event = "form_submit" → GA4 Event Tag.
  // ---------------------------------------------------------------------------
  function classifyForm(form) {
    var id = form.id || '';
    var action = (form.getAttribute('action') || '').toLowerCase();

    if (id.indexOf('customer-service') !== -1) return 'customer_service';
    if (id.indexOf('sales-form') !== -1)       return 'sales_inquiry';
    if (id.indexOf('newsletter') !== -1)       return 'newsletter';
    if (id.indexOf('black-friday') !== -1)     return 'promo_bf';
    if (id.indexOf('xmas') !== -1)             return 'promo_xmas';
    if (action.indexOf('/contact') !== -1)     return 'contact';
    if (action.indexOf('/cart') !== -1)        return 'cart';          // exclude below
    if (action.indexOf('search') !== -1)       return 'search';        // exclude below
    return id || 'unknown';
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;

    var formType = classifyForm(form);

    // Skip noisy internal forms
    if (formType === 'cart' || formType === 'search') return;

    window.dataLayer.push({
      event: 'form_submit',
      form_id: form.id || null,
      form_type: formType,
      form_location: window.location.pathname
    });
  }, true);

  // ---------------------------------------------------------------------------
  // 2. UTM PRESERVATION
  // ---------------------------------------------------------------------------
  // Captures utm_* + gclid + fbclid from landing URL, stores in localStorage
  // for 30 days, and writes to Shopify cart attributes so attribution survives
  // through to the order. Fixes the 5.74% unassigned-traffic problem.
  // ---------------------------------------------------------------------------
  var TRACK_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  var STORAGE_KEY = 'mwf_attribution';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.ts || Date.now() - parsed.ts > TTL_MS) return null;
      return parsed.data || null;
    } catch (err) { return null; }
  }

  function writeStored(data) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), data: data }));
    } catch (err) { /* storage full / disabled */ }
  }

  function captureFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var found = {};
    var any = false;
    TRACK_KEYS.forEach(function (k) {
      var v = params.get(k);
      if (v) { found[k] = v; any = true; }
    });
    return any ? found : null;
  }

  function syncToCart(attrs) {
    if (!attrs || Object.keys(attrs).length === 0) return;
    var body = { attributes: {} };
    Object.keys(attrs).forEach(function (k) { body.attributes[k] = attrs[k]; });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { /* silent */ });
  }

  var fromUrl = captureFromUrl();
  if (fromUrl) {
    writeStored(fromUrl);
    syncToCart(fromUrl);
  } else {
    var stored = readStored();
    if (stored) syncToCart(stored);
  }
})();
